var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCross = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.406796 0.395802C0.949191 -0.131934 1.82859 -0.131934 2.37098 0.395802L10 7.81863L17.629 0.395802C18.1714 -0.131934 19.0508 -0.131934 19.5932 0.395802C20.1356 0.923537 20.1356 1.77917 19.5932 2.3069L11.6864 10L19.5932 17.6931C20.1356 18.2208 20.1356 19.0765 19.5932 19.6042C19.0508 20.1319 18.1714 20.1319 17.629 19.6042L10 12.1814L2.37098 19.6042C1.82859 20.1319 0.949191 20.1319 0.406796 19.6042C-0.135599 19.0765 -0.135599 18.2208 0.406796 17.6931L8.31359 10L0.406796 2.3069C-0.135599 1.77917 -0.135599 0.923537 0.406796 0.395802Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross.37c1353a0b6a94503ceb238d02affd4f.svg";